import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';
import { List, ListProps } from 'yoso';
import styles from './Tabs.module.scss';

export type TabsProps = ListProps & {
  variant?: 'underline';
};

export const Tabs = forwardRef(function Tabs(
  { className, variant, ...props }: TabsProps,
  ref: ForwardedRef<HTMLOListElement>
) {
  return (
    <List
      className={classNames(styles.root, styles[variant || ''], className)}
      {...props}
      ref={ref}
    />
  );
});
